export enum FormStatusTypes {
  VALID = 'VALID',
  INVALID = 'INVALID',
}

export interface FormErrors {
  [key: string]: string;
}

export interface FormModel<TItem> {
  model: TItem | null;
  dirty: boolean;
  status: FormStatusTypes;
  errors: FormErrors;
}

export const FormModelDefault = {
  model: null,
  dirty: false,
  status: FormStatusTypes.VALID,
  errors: {},
};

export function getFormModelDefault<TItem>(
  overrides: Partial<FormModel<TItem>> = FormModelDefault
): FormModel<TItem> {
  const rv = { ...FormModelDefault, ...overrides };
  return rv;
}
